module.exports = __webpack_public_path__ + "static/build-logo-eb71985c33b8d2af827a0bdfd5e91ed5.png";